import React from 'react';
import PropTypes from 'prop-types';
import TablePagination from "@material-ui/core/TablePagination";
import TableFooter from "@material-ui/core/TableFooter";
import TableRow from "@material-ui/core/TableRow";

import Actions from './Actions';
import PaginationContext from "./context";

class Pagination extends React.Component {

    static contextType = PaginationContext;

    static propTypes = {
        colSpan: PropTypes.number.isRequired,
    };

    handleChangePage(event, page) {
        const {path} = this.context;
        window.location = `${path}?page=${page + 1}`;
    }

    render() {
        const {total, per_page, current_page} = this.context;
        return (
            <TableFooter>
                <TableRow>
                    <TablePagination
                        colSpan={this.props.colSpan}
                        count={total}
                        page={current_page - 1}
                        rowsPerPage={per_page}
                        rowsPerPageOptions={[]} // disable this
                        onChangePage={this.handleChangePage.bind(this)}
                        ActionsComponent={Actions}
                    />
                </TableRow>
            </TableFooter>
        )
    }
};

export default Pagination;


// WEBPACK FOOTER //
// ./resources/assets/js/components/Pagination/Pagination.jsx